import { cdnImages } from "../../utils/imageMap.cdn";
import { RotateWords } from "../RotateWords/RotateWords";
import { Heading } from "../ui/Heading/Heading";

const awardData = [
  {
    img: cdnImages.awards.award1,
    description:
      "Afaqs marketers’ cellence Awards 2025 Design- best spatial design",
  },
  {
    img: cdnImages.awards.award6,
    description:
      "EEMA Spotlight Awards 2025 for Best use of multimedia techology",
  },
  {
    img: cdnImages.awards.award3,
    description:
      "WOW Awards 2025 Achievement in Audio-visual film for an event",
  },
  {
    img: cdnImages.awards.award4,
    description:
      "EEMAxGLOBAL Awards 2025 for installation/ Government show of the year",
  },
  {
    img: cdnImages.awards.award5,
    description: "EEMA Spotlight Awards 2025 for Best AV production",
  },
  {
    img: cdnImages.awards.award2,
    description: "EEMA Spotlight Awards 2025 for Best AV production",
  },
];

const descriptions = [
  "Afaqs marketers’ cellence Awards 2025 Design- best spatial design",
  "EEMA Spotlight Awards 2025 for Best use of multimedia techology",
  "EEMA Spotlight Awards 2025 for Best AV production",
  "WOW Awards 2025 Achievement in Audio-visual film for an event",
  "WOW Awards 2025 for Innovation in virtual reality for an event",
  "WOW Awards 2025 for AR/vR Technologies and content for an event",
  "WOW Awards 2025 Special event of the year for govt/ federation/ Association (Upto 10Cr)",
  "EEMAxGLOBAL Awards 2025 for installation/Government show of the year",
  "EEMAxGLOBAL Awards 2025 for Celebratory event of the year",
  "EEMAxGLOBAL Awards 2025 for B2C exhibition of the year",
  "EEMAxGLOBAL Awards 2025 for Government Event of the year - Large",
  "EEMAxGLOBAL Awards 2025 for Debut IP of the year",
  "EEMAxGlobal 2025 For Government event of the year - Small",
  "EEMAxGlobal 2025 for Installations/government show of the year",
];

export const Awards = () => {
  return (
    <div className="w-screen h-full flex flex-col justify-between items-center gap-10 md:gap-24">
      <Heading placeholder="Our Awards" />
      <div className=" mb-12 w-5/6 h-3/5 grid md:grid-flow-col grid-cols-12">
        {awardData.map((award, index) =>  {
          return (
            <div
              className="  col-span-12 md:col-span-2 h-full flex flex-row md:flex-col w-full  "
              key={index}
            >
              <div className=" h-full md:h-2/5 w-2/5 md:w-full border-2 border-white flex justify-center p-8 md:p-6">
                <img src={award.img} alt="img" className=" w-full h-full object-contain " />
              </div>

              <div className=" h-full md:h-3/5 w-3/5 md:w-full text-[14px] md:text-[16px] border-2 border-white my-auto pt-4 md:pt-16 px-4 ">
                <RotateWords words={descriptions} className=" text-[14px] md:text-[16px] leading-normal tracking-normal block text-left" />
              </div>
            </div>
          )
        })}
      </div>
    </div>
  );
};
